import { useEffect, useRef, useState } from 'react'
import toast, { Toaster } from 'react-hot-toast'
import { useSearchParams } from 'react-router-dom'
import { Back } from '../../components/buttons/backButton/Back'
import { MoveZone } from '../../components/zone/moveZone/MoveZone'
import { translations } from '../../configs/translations'
import { Language } from '../../context/LanguageContext'
import { RaceTypes } from '../../enums/RaceTypes'
import { UserProfile } from '../../models/UserProfile'
import { ClientApi } from '../../services/clientApi'
import UserService from '../../services/UserService'
import { VehicleService } from '../../services/VehicleService'
import { NuiCallbacks } from '../../utils/ClientEvents'
import { Header } from '../main/header/Header'
import { VehicleSpec } from '../main/vehicleSpec/VehicleSpec'
import './Preview.css'
import { PreviewBottomMenu } from './preview-bottom-menu/PreviewBottomMenu'
import { PreviewMenu } from './preview-menu/PreviewMenu'


export const Preview = () => {

	const [userProfile, setUserProfile] = useState<UserProfile | null>(JSON.parse(localStorage.getItem('profile') || 'null'))
	const [searchParams] = useSearchParams()
	const vehicleId = Number(searchParams.get('vehicleId') || -1)
	const [language, setLanguage] = useState<Language>('ru')
	const t = translations[language]

	const [modelName, setModelName] = useState('')

	useEffect(() => {
		if (!vehicleId) return

		VehicleService.previewVehicle(vehicleId)
			.catch((error) => {
				toast.error(
					error &&
						error.response &&
						error.response.data &&
						t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})

		VehicleService.getVehicleModelNameById(vehicleId)
			.then(modelName => {
				setModelName(modelName)
			})
			.catch((error) => {
				toast.error(
					error &&
						error.response &&
						error.response.data &&
						t[error.response.data as keyof typeof t]
						? t[error.response.data as keyof typeof t]
						: t.error_unknown,
					{ className: 'notification-error' }
				)
			})
	}, [vehicleId])

	const cursorRafRef = useRef<number | null>(null)
	useEffect(() => {
		return () => {
			if (cursorRafRef.current !== null) cancelAnimationFrame(cursorRafRef.current)
		}
	}, [])

	const handlePreviewCursorMove = (event: React.MouseEvent) => {
		if (cursorRafRef.current !== null) return
		const { clientX, clientY } = event
		cursorRafRef.current = requestAnimationFrame(() => {
			cursorRafRef.current = null
			ClientApi.send(NuiCallbacks.PREVIEW_CURSOR, {
				x: clientX / window.innerWidth,
				y: clientY / window.innerHeight,
			})
		})
	}

	const handlePreviewClick = () => {
		ClientApi.send(NuiCallbacks.PREVIEW_CLICK, {})
	}

	return (<>
		<Header
			profile={userProfile}
			setProfile={setUserProfile}
			selectedMode={RaceTypes.RANKED}
			selectedVehicle={null}
			title={t.preview}
		/>


		<div className='preview'>
			<Back
				containerStyles={{
					backgroundColor: 'rgba(255, 255, 255, 1)',
					padding: '20px',
					color: '#000',
					gap: '10px',
				}}
				imgStyle={{
					filter: 'brightness(0)',
				}}
				onClick={() => UserService.openLobby()}
			/>
			<PreviewMenu vehicleId={vehicleId} />
			<MoveZone carId={vehicleId} onMouseMove={handlePreviewCursorMove} onClick={handlePreviewClick} />
			{modelName && <VehicleSpec modelName={modelName} />}
			{vehicleId && <PreviewBottomMenu vehicleId={vehicleId} />}
		</div>

		<Toaster
			position="bottom-center"
			toastOptions={{
				duration: 2000,
			}}
		/>
	</>)

}